import { useFormik } from 'formik'
import useSnackbarAlert from 'hooks/useSnackbar'
import _ from 'lodash'
import { vehicleValidationSchema } from 'pages/Bus/helpers/validationSchema'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import {
  ev_vehicle_options,
  filterByFuelType,
  hv_vehicle_weight_option,
  ice_vehicle_options,
  options_with_id,
} from '../helpers/hv_helper'

const useVehicle = () => {
  const local_vehicle_data = JSON.parse(localStorage.getItem('hv_data') || '[]')
  const history = useHistory()
  const { setSnackbar } = useSnackbarAlert()

  const [hvTcoData, setHvTcoData] = useState([...local_vehicle_data])

  const [vehicle_data, set_vehicle_data] = useState([...local_vehicle_data])

  const [hvVehicleWeightClass, setHvVehicleWeightClass] = useState([
    ...hv_vehicle_weight_option(hvTcoData),
  ])
  const [iceChassisOptions, setIceChassisOptions] = useState([...ice_vehicle_options(hvTcoData)])

  const [evChassisOptions, setEvChassisOptions] = useState([...ev_vehicle_options(hvTcoData)])

  const [vehicleById, setVehicleById] = useState<any>({})
  const [payload, setPayload] = useState<undefined | number>()
  const [savedData, setSavedData] = useState<{ [key: string]: any }>([])
  // console.log('🚀 ~ savedData:', savedData)
  const savedDataJson = JSON.parse(localStorage.getItem('vehicle_data') || '{}')

  const initialValues = {
    heavy_vehicle_weight_class: savedData.heavy_vehicle_weight_class || '',
    ice_chassis: savedData.ice_chassis || '',
    replacement_electric_vehicle_chassis: savedData.replacement_electric_vehicle_chassis || '',
    auxiliary_load: savedData.auxiliary_load || 'refrigerated_truck',
    body_coast: savedData.body_coast || '',
    working_days: savedData.working_days || ['mon', 'tue', 'wed', 'thu', 'fri'],
    distance_travelled_per_day: savedData.distance_travelled_per_day || '',
    terrain: savedData.terrain || 'Flat',
    vehicle_payload: savedData.vehicle_payload || '',
  }

  const onHandleSubmit = (values: any) => {
    const { working_days } = values
    if (working_days.length < 1 && formik.isSubmitting) {
      return setSnackbar({
        message: 'Please select working days',
        variant: 'warning',
      })
    }
    history.push({ pathname: '/vehicle-calculator', state: { ...values } })
    localStorage.setItem('vehicle_data', JSON.stringify(values))
  }

  const vehicleObject = (prevData: any, vehicleData: any) => ({
    id: _.toString(prevData.length + 1),
    ...vehicleData,
  })

  const onHandleClickUpdate = (input_data: any, vehicle_id: any) => {
    set_vehicle_data((prevData: any) => {
      const findIndex = prevData.findIndex((x: any) => x.id === vehicle_id)
      prevData[findIndex] = { ...input_data, id: vehicle_id }
      return [...prevData]
    })
  }

  const onHandleClickAddvehicle = (input_data: any) => {
    set_vehicle_data((prevData) => [...prevData, vehicleObject(prevData, input_data)])
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: vehicleValidationSchema(payload),
    onSubmit: async (values) => onHandleSubmit(values),
    enableReinitialize: true,
  })

  useEffect(() => {
    if (formik?.values?.heavy_vehicle_weight_class) {
      setHvTcoData(
        _.filter(
          vehicle_data,
          (item: any) =>
            item.heavy_vehicle_weight_class === formik?.values.heavy_vehicle_weight_class,
        ),
      )
    }
  }, [formik.values, vehicle_data]) //eslint-disable-line

  useEffect(() => {
    const iceData = filterByFuelType(hvTcoData, 'diesel')
    const evData = filterByFuelType(hvTcoData)

    const iceDataOptions = options_with_id(iceData, 'ice')
    const evDataOptions = options_with_id(evData, 'ev')

    setIceChassisOptions(iceDataOptions)
    setEvChassisOptions(evDataOptions)
    // setIceChassisOptions()
    // const
    // setIceChassisOptions()
  }, [hvTcoData, formik.values, vehicle_data])

  useEffect(() => {
    const vehicleId = formik?.values?.replacement_electric_vehicle_chassis

    const evVehicle = vehicleId && _.find(vehicle_data, { id: vehicleId })

    if (evVehicle) {
      setVehicleById({ ...evVehicle })
    }
  }, [evChassisOptions, formik.values]) //eslint-disable-line

  useEffect(() => {
    if (vehicleById) {
      setPayload(vehicleById.payload)
    }
  }, [vehicleById])

  useEffect(() => {
    setSavedData(savedDataJson)
  }, [savedDataJson.length]) //eslint-disable-line

  useEffect(() => {
    localStorage.setItem('hv_data', JSON.stringify(vehicle_data))
    setHvVehicleWeightClass([...hv_vehicle_weight_option(vehicle_data)])
  }, [localStorage, vehicle_data]) //eslint-disable-line

  useEffect(() => {
    setHvTcoData(local_vehicle_data)
    set_vehicle_data(local_vehicle_data)
  }, [localStorage]) //eslint-disable-line

  // useEffect(() => {
  //   if (formik.values.ice_chassis) {
  //     formik.setFieldValue('ice_chassis', '')
  //   }
  //   if (formik.values.replacement_electric_vehicle_chassis) {
  //     formik.setFieldValue('replacement_electric_vehicle_chassis', '')
  //   }
  // }, [formik.values.heavy_vehicle_weight_class]) //eslint-disable-line

  return {
    formik,
    iceChassisOptions,
    evChassisOptions,
    hvVehicleWeightClass,
    payload,
    set_vehicle_data,
    hvTcoData,
    onHandleClickUpdate,
    onHandleClickAddvehicle,
  }
}

export default useVehicle
